export default "__VITE_ASSET__XHmuJ_lm__"